import './NoteDrawer.scss';

/**
 * FootNote Properties
 */
export interface NoteDrawer {
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const NoteDrawer = ({ drawerOpen, setDrawerOpen }: NoteDrawer) => {
  return (
    <div
      className={`RPA_PE-drawer-backdrop
        ${drawerOpen ? 'opened' : 'closed'} RPA_PE-drawer-transition`}
      onClick={() => setDrawerOpen(false)}
    ></div>
  );
};

export default NoteDrawer;
